import React from 'react';
import classNames from 'classnames';
import Flex from 'components/common/Flex';
import PropTypes from 'prop-types';
import { Card, Col, Form, ProgressBar, Row, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const getTotalPrice = items =>
  items
    .map(({ unit, price }) => unit * price)
    .reduce((total, currentValue) => total + currentValue, 0);

const getProductItemCalculatedData = (unit, price, totalPrice) => {
  const productTotalPrice = unit * price;
  const percentage = ((productTotalPrice * 100) / totalPrice).toFixed(0);
  return { productTotalPrice, percentage };
};

const Project = ({ project, totalPrice, isLast }) => {
  const { title, description, unit, price } = project;
  const { productTotalPrice, percentage } = getProductItemCalculatedData(
    unit,
    price,
    totalPrice
  );

  return (
    <tr className={classNames({ 'border-bottom border-200': !isLast })}>
      <td>
        <Flex alignItems="center" className="position-relative">
          <div className="ms-3">
            <h6 className="mb-1 fw-semibold">
              <Link className="text-1100 stretched-link" to="#!">
                {title}
              </Link>
            </h6>
            <p className="fw-semibold mb-0 text-500">{description}</p>
          </div>
        </Flex>
      </td>
      <td className="align-middle text-end fw-semibold">
        ${productTotalPrice}
      </td>
      <td className="align-middle pe-x1">
        <Flex alignItems="center">
          <ProgressBar now={percentage} style={{ width: '80px', height: 5 }} />
          <div className="fw-semibold ms-3">{percentage}%</div>
        </Flex>
      </td>
    </tr>
  );
};

Project.propTypes = {
  totalPrice: PropTypes.number.isRequired,
  isLast: PropTypes.bool,
  project: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    unit: PropTypes.number.isRequired,
    price: PropTypes.number.isRequired
  }).isRequired
};

const Projects = ({ projects }) => {
  const totalPrice = getTotalPrice(projects);
  const noOfProducts = projects.length;

  return (
    <Card className="h-lg-100 overflow-hidden">
      <Card.Body className="p-0 ">
        <Table borderless responsive className="mb-0 fs-10">
          <thead className="bg-body-tertiary">
            <tr>
              <th className="text-900">Projects</th>
              <th className="text-900 text-end">Revenue ( ${totalPrice})</th>
              <th className="pe-x1 text-900 text-end" style={{ width: '8rem' }}>
                Revenue (%)
              </th>
              <th className="text-900 text-end" style={{ width: '12rem' }}>
                Allotted Budget ( ${totalPrice})
              </th>
              <th className="text-900 text-end" style={{ width: '10rem' }}>
                Actual Cost ( ${totalPrice})
              </th>
            </tr>
          </thead>
          <tbody>
            {projects.map((project, index) => (
              <Project
                project={project}
                totalPrice={totalPrice}
                isLast={index === noOfProducts - 1}
                key={project.id}
              />
            ))}
          </tbody>
        </Table>
      </Card.Body>
      <Card.Footer className="bg-body-tertiary py-2">
        <Row className="flex-between-center">
          <Col xs="auto">
            <Form.Select size="sm" className="me-2">
              <option>Last Month</option>
              <option>Last Year</option>
            </Form.Select>
          </Col>
        </Row>
      </Card.Footer>
    </Card>
  );
};

Projects.propTypes = {
  projects: PropTypes.arrayOf(Project.propTypes.project).isRequired
};

export default Projects;
